import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import AutocompleteBase from './AutocompleteBase';
import SearchIcon from '@material-ui/icons/Search';

class Autocomplete extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override AutocompleteBase */
    styleType: PropTypes.string,
    /** Floating label */
    label: PropTypes.string.isRequired,
    /** Default value to seed uncontrolled component */
    defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    /** Async function used to load in AutoComplete data */
    loadOptions: PropTypes.func.isRequired,
    /** Hide search icon when value selected */
    hideIconOnSelect: PropTypes.bool,
    /** Add custom footer after AutoComplete */
    footer: PropTypes.func,
    /** Function to override default filtering */
    onFilter: PropTypes.func,
    /** Function to override default option rendering */
    renderOption: PropTypes.func,
    /** Function to override default value rendering */
    renderValue: PropTypes.func,
    /** Callback function that fires when autocomplete adds/removes values */
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    styleType: 'default',
    defaultValue: null,
    hideIconOnSelect: false,
    onFilter: null,
    onChange: null,
  };

  getStyles = (type, props) => {
    switch (type) {
      case 'emailCases':
        return {
          '@global': {
            '.emailCases .Select-value': {
              '&:after': {
                content: '"" !important',
              },
            },
          },
        };
      case 'serviceInitiation':
        return {
          root: {
            width: '100%',
            border: 'none',
            backgroundColor: '#F6F6FA',
          },
          floatLabel: {
            margin: '0 0 0 2rem',
          },
          floatLabelShrink: {
            margin: '0.5rem 0 0 2rem',
            fontSize: '10px',
          },
          '@global': {
            '.Select-multi-value-wrapper': {
              // backgroundColor: '#F6F6FA',
            },
            '.Select-noresults': {
              fontSize: '14px',
              paddingLeft: '28px',
            },
            '.Select-menu': {
              maxHeight: '240px',
              overflowY: 'auto',
            },
            '.Select-clear': {
              fontSize: '33px',
              color: '#000',
              fontWeight: 'bold',
              position: 'relative',
              top: '-5px',
              left: '-7px',
              backgroundColor: '#F6F6FA',
              zIndex: 100,
            },
            '.Select-menu div': {
              height: '64px',
              overflowY: 'scroll',
              whiteSpace: 'normal',
              fontSize: '12px',
              display: 'flex',
              wordBreak: 'break-word',
              alignItems: 'center',
            },
            '.Select-menu-outer': {
              boxShadow: 'none',
              position: 'inherit',
              marginTop: '0px',
              backgroundColor: '#FFF',
              border: 'none',
              //overflowY: 'auto',
              //maxHeight: '240px',
            },
            '.Select--multi .Select-input': {
              margin: '0 0 0 2rem',
            },
            '.Select--multi .Select-value': {
              margin: '5px 5px 0px 0px',
            },
            '.Select.is-focused:not(.is-open) > .Select-control': {
              boxShadow: 'none',
              background: '#F6F6FA',
            },
            '.Select.is-focused > .Select-control': {
              background: '#F6F6FA',
            },
            '.Select-option.is-focused': {
              backgroundColor: '#F6F6FA',
            },
            '.Select-arrow-zone, .Select-clear-zone': {
              display: 'inline-block',
              margin: '0 1rem 0.5rem 0',
            },
            '.Select-input': {
              marginLeft: '2rem',
            },
            '.Select-value': {
              '&:after': {
                content: 'none',
              },
            },
          },
        };
      case 'AddressLookUPProfile':
        return {
          root: {
            width: '100%',
            // margin: '0 0 0 1.5rem',
            border: '0.5px solid #EAEAF2',
            backgroundColor: '#F6F6FA',
            maxWidth: '520px',
            // height: label.length > 41 && props.useEllipsisLabel === false ? '68px' : '48px',
          },
          floatLabel: {
            paddingLeft: '16px',
          },
          floatLabeldisable: {
            margin: '0',
            color: '#aa9fa2',
          },
          floatLabelShrink: {
            margin: '0',
            transformOrigin: 'top left',
            left: '0',
            transform: 'translate(0, 8px) scale(0.75)',
            fontSize: '1rem',
            // color: "#747480",
          },
          '@global': {
            '.Select-multi-value-wrapper': {
              // backgroundColor: '#F6F6FA',
            },

            '.Select--multi .Select-input': {
              margin: '0 0 0 2rem',
            },
            '.Select--multi .Select-value': {
              margin: '5px 5px 0px 0px',
            },
            '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
              padding: 0,
            },
            '.Select.is-focused:not(.is-open) > .Select-control': {
              boxShadow: 'none',
              background: '#F6F6FA',
            },
            '.Select.is-focused > .Select-control': {
              background: '#F6F6FA',
            },
            '.Select-option.is-focused': {
              backgroundColor: '#F6F6FA',
            },
            '.Select-arrow-zone, .Select-clear-zone': {
              display: 'inline-block',
              margin: '0 0 0.5rem 0',
            },
            '.Select-input': {
              marginLeft: '12px',
            },
            '.Select-value': {
              marginLeft: '12px',
              '&:after': {
                content: 'none',
              },
            },
          },
        };
      case 'AddressLookUP':
        return {
          floatLabel: {
            paddingLeft: '8px',
          },
          '@global': {
            '.Select-input': {
              marginLeft: props.align === 'C' ? '10px' : '0px', // IE 11 center align fix
            },
            '.Select-value': {
              marginLeft: props.align === 'C' ? '10px' : '0px', // IE 11 center align fix
              '&:after': {
                content: 'none',
              },
            },
          },
        };
      case 'casesLanding':
        return {
          root: {
            width: '100%',
            // margin: '0 0 0 1.5rem',
            border: '0.5px solid #EAEAF2',
            backgroundColor: '#F6F6FA',
          },
          floatLabel: {
            margin: '0 0 0 2rem',
          },
          floatLabelShrink: {
            margin: '0.5rem 0 0 2rem',
            fontSize: '10px',
          },
          '@global': {
            '.Select-multi-value-wrapper': {
              // backgroundColor: '#F6F6FA',
            },
            '.Select--multi .Select-input': {
              margin: '0 0 0 2rem',
            },
            '.Select--multi .Select-value': {
              margin: '5px 5px 0px 0px',
            },
            '.Select.is-focused:not(.is-open) > .Select-control': {
              boxShadow: 'none',
              background: '#F6F6FA',
            },
            '.Select.is-focused > .Select-control': {
              background: '#F6F6FA',
            },
            '.Select-option.is-focused': {
              backgroundColor: '#F6F6FA',
            },
            '.Select-arrow-zone, .Select-clear-zone': {
              display: 'inline-block',
              margin: '0 1rem 0.5rem 0',
            },
            '.Select-input': {
              marginLeft: '2rem',
            },
            '.Select-value': {
              '&:after': {
                content: 'none',
              },
            },
          },
        };
      default:
        return {};
    }
  };

  getSettings = type => {
    switch (type) {
      case 'emailCases':
        return {
          renderOption: data => {
            return (
              <div className="autocomplete-item-wrapper">
                <div className="autocomplete-item-name">
                  {intl.get('messaging.details.caseId')}: {data.caseId}
                </div>
                <div className="autocomplete-item-email">{`${data.firstName} ${data.lastName}`}</div>
                <div className="autocomplete-item-company">{data.engagement}</div>
              </div>
            );
          },
          renderValue: conf => {
            const { value } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: 'black' }}>{`${value.caseId}, ${value.firstName} ${value.lastName}, ${value.engagement}`} </span>
              </div>
            );
          },
        };
      case 'email':
        return {
          renderOption: data => {
            return (
              <div className="autocomplete-item-wrapper">
                <div className="autocomplete-item-name">{`${data.firstName} ${data.lastName}`}</div>
                <div className="autocomplete-item-email">{data.emailId}</div>
                <div className="autocomplete-item-company">{data.engagement}</div>
              </div>
            );
          },
          renderValue: conf => {
            const { children, value } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: 'black' }}>{`${value.firstName} ${value.lastName}`} </span>
                <strong>{`(${children[0]})`}</strong>
              </div>
            );
          },
        };

      case 'serviceInitiation':
        return {
          renderIcon: () => {
            return <SearchIcon />;
          },
          renderOption: (data, searchText) => {
            // swapped when CPS provides avatars finally
            const avatarURL = process.env.PUBLIC_URL + '/images/avatar-placeholder.svg';
            const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);

            const employeeName = `<p class="inner-content"><span class="item-content">${highlight(
              searchText,
              data.employeeName,
            )}</span> <span class="item-engagement">${data.engagement}</span></p>`;
            if (!data.location) data.location = 'Atlanta, GA - United States';

            data.dateOfBirth = data.dateOfBirth !== null ? data.dateOfBirth.split(' ')[0] : '';

            return (
              <div className="autocomplete-item-wrapper serviceinit">
                <div className="autocomplete-item-icon">
                  <img src={avatarURL} border="0" alt="Person profile" />
                </div>
                <div className="autocomplete-item-name" dangerouslySetInnerHTML={{ __html: employeeName }} />
                <div className="autocomplete-item-location">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('autocomplete.location')}</span>
                    <span className="item-content">{data.location}</span>
                  </p>
                </div>
                <div className="autocomplete-item-email">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('autocomplete.email')}</span>
                    <span className="item-content">{data.email}</span>
                  </p>
                </div>
                <div className="autocomplete-item-dob">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('autocomplete.birth')}</span>
                    <span className="item-content">{data.dateOfBirth}</span>
                  </p>
                </div>
              </div>
            );
          },
          renderValue: conf => {
            const { value } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: 'black', marginLeft: '2rem' }}>{`${value.employeeName}`} </span>
              </div>
            );
          },
        };
      case 'AddressLookUP':
        return {
          renderIcon: () => {
            return <SearchIcon />;
          },
          renderOption: (data, searchText, labelKey) => {
            let employeeName = '';

            const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);
            const highlight2 = (needle, haystack) => haystack.replace(needle, str => `<strong>${str}</strong>`);
            let regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            if (regex.test(searchText) === true) {
              employeeName = `<p class="inner-content"><span class="item-content">${highlight2(
                searchText,
                data['smartLookUp'],
              )}</span></p>`;
            } else {
              employeeName = `<p class="inner-content"><span class="item-content">${highlight(searchText, data['smartLookUp'])}</span></p>`;
            }

            return (
              <div className="autocomplete-item-wrapper ">
                <div
                  className="autocomplete-item-name"
                  style={{ 'white-space': 'break-spaces' }}
                  dangerouslySetInnerHTML={{ __html: employeeName }}
                />
              </div>
            );
          },
          renderValue: (conf, labelKey) => {
            const { value } = conf;
            let val = '';
            if (value[labelKey] !== null) {
              val = value[labelKey];
            }
            return (
              <div className="Select-value">
                <span style={{ color: 'black' }}>{`${val}`} </span>
              </div>
            );
          },
        };
      case 'AddressLookUPProfile':
        return {
          renderIcon: () => {
            return <SearchIcon />;
          },
          renderOption: (data, searchText, labelKey) => {
            let employeeName = '';

            const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);
            const highlight2 = (needle, haystack) => haystack.replace(needle, str => `<strong>${str}</strong>`);
            let regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            if (regex.test(searchText) === true) {
              employeeName = `<p class="inner-content"><span class="item-content">${highlight2(
                searchText,
                data['smartLookUp'],
              )}</span></p>`;
            } else {
              employeeName = `<p class="inner-content"><span class="item-content">${highlight(searchText, data['smartLookUp'])}</span></p>`;
            }

            return (
              <div className="autocomplete-item-wrapper ">
                <div
                  className="autocomplete-item-name"
                  style={{ 'white-space': 'break-spaces' }}
                  dangerouslySetInnerHTML={{ __html: employeeName }}
                />
              </div>
            );
          },
          renderValue: (conf, labelKey, isDisable) => {
            const { value } = conf;
            let val = '';
            if (value[labelKey] !== null) {
              val = value[labelKey];
            }
            let style = !isDisable ? { color: 'black' } : {};
            return (
              <div className="Select-value">
                <span style={style}>{`${val}`} </span>
              </div>
            );
          },
        };
      case 'casesLanding':
        return {
          renderIcon: () => {
            return <SearchIcon />;
          },
          renderOption: data => {
            return (
              <div className="autocomplete-item-wrapper">
                <div className="autocomplete-item-name">{`${data.firstName} ${data.lastName}`}</div>
                <div className="autocomplete-item-email">{data.emailId}</div>
                <div className="autocomplete-item-company">{data.engagement}</div>
              </div>
            );
          },
          renderValue: conf => {
            const { value } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: 'black', marginLeft: '2rem' }}>{`${value.firstName} ${value.lastName}`} </span>
                <strong>{`(${value.emailId})`}</strong>
              </div>
            );
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType } = this.props;
    const styles = this.getStyles(styleType, this.props);
    const settings = this.getSettings(styleType);

    return <AutocompleteBase {...settings} styles={styles} {...this.props} />;
  }
}

export default Autocomplete;
